import { DataGrid } from "@mui/x-data-grid";
import { CircularProgress, Paper } from "@material-ui/core";

const TableWithPagination = ({
  tableColumns,
  pageState,
  searchQuery,
  getDataByPage,
  setNewPage,
  setNewPageSize,
  handleRowClick,
}) => {
  return (
    <div className="postion-relative">
      <DataGrid
        rows={pageState.data}
        rowCount={pageState.total}
        pagination
        page={pageState.page}
        columns={tableColumns}
        pageSize={pageState.pageSize}
        rowsPerPageOptions={[10]}
        paginationMode="server"
        onPageChange={(newPage) => {
          if (searchQuery == "") {
            getDataByPage(newPage, 10);
          } else {
            getDataByPage(newPage, 10);
          }
          setNewPage(newPage);
        }}
        onCellClick={(param) => handleRowClick(param.row)}
        onPageSizeChange={(newPageSize) => setNewPageSize(newPageSize)}
        sx={{
          color: "black",
          fontFamily: "Rajdhani-SemiBold",
          fontSize: "18px",
          backgroundColor: "white",
          borderBottomLeftRadius: "12px",
          borderBottomRightRadius: "12px",
        }}
        autoHeight
        disableColumnMenu
        disableSelectionOnClick
        disableColumnSelector
        getRowHeight={() => "auto"}
      />
      {pageState?.isLoading && (
        <div className="position-absolute top-0 start-0 d-flex align-items-center justify-content-center w-100 h-100 blur-filter-background">
          <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
            <CircularProgress
              className="rounded-circle"
              color="success"
              sx={{ fontSize: 10, color: "#002244" }}
              disableShrink
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default TableWithPagination;
